import { gql } from '@apollo/client';

export const PRODUCE_SITE_AVAILABILITIES = gql`
  mutation Mutation($input: ProduceSiteAvailabilitiesInput!) {
    produceSiteAvailabilities(input: $input) {
      id
    }
  }
`;

export const PRODUCE_SITE_AVAILABILITIES_UPDATE = gql`
  mutation Mutation($input: ProduceSiteAvailabilityUpdatesInput!) {
    produceSiteAvailabilityUpdates(input: $input) {
      id
    }
  }
`;

export const PRODUCE_ASSET_AVAILABILITIES = gql`
  mutation Mutation($input: ProduceAssetAvailabilitiesInput!) {
    produceAssetAvailabilities(input: $input) {
      id
    }
  }
`;

export const PRODUCE_ASSET_AVAILABILITIES_UPDATE = gql`
  mutation Mutation($input: ProduceAssetAvailabilityUpdatesInput!) {
    produceAssetAvailabilityUpdates(input: $input) {
      id
    }
  }
`;
